import React, { useEffect, useState, useRef } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import _ from "lodash/fp";
import html2pdf from "html2pdf.js";
import label from '../../labels/interviewProcess_en.json';
import commonLabels from "../../../common/labels/common_en.json";
import {
  getAdvertisementsList,
  getExamslistByAdvertisementId,
} from "../../../postExaminationProcessObjective/actions/postExaminationProcessObjectiveActions";
import { getAllotmentChartByExamId } from "../../actions/interviewProcessActions";
import { getYearList, getMainsAdvertisements } from "../../../common/actions/commonActions";


const AllotmentChartReport = () => {

  const pdfRef = useRef(null);

  const { register, handleSubmit, errors } = useForm(
    {
      mode: "onChange",
    }
  );

  let { getAllotmentChartData } = useSelector(
    (state) => state.interviewProcessReducer,
    shallowEqual
  );

  let { advertisementList, examList } = useSelector(
    (state) => state.postExamProcessObjectReducer,
    shallowEqual
  );
  let { yearList, getMainsAdvertisement } = useSelector(
    (state) => state.common,
    shallowEqual
  );

  const [selectedAdvertNo, setSelectedAdvertNo] = useState("");
  const [selectedExam, setSelectedExam] = useState("");
  const [reloadItem, setReloadItem] = useState(true);
  const [saveButtonFlag, setSaveButtonFlag] = useState(true);
  const [confirmClicked, setConfirmClicked] = useState(false);
  const [printFlag, setPrintFlag] = useState(true);
  const [selectedYear, setSelectedYear] = useState("");
  const [interviewData, setInterviewData] = useState([]);
  const session = JSON.parse(sessionStorage.getItem("session"));
  const dispatch = useDispatch();

  useEffect(() => {
    window.scrollTo(0, 0);
    dispatch(getYearList());
    setReloadItem(!reloadItem);
    onCancelButton();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (getAllotmentChartData) {
      setInterviewData(getAllotmentChartData);
    }
  }, [getAllotmentChartData]);

  useEffect(() => {
    setPrintFlag(interviewData.length === 0);
  }, [interviewData]);

  const onAdvertisementChange = (ele) => {
    setSelectedAdvertNo(ele);
    setSelectedExam("");
    setSaveButtonFlag(true);
    setConfirmClicked(false);
    setPrintFlag(true);
    examList.length = 0;
    ele && dispatch(getExamslistByAdvertisementId(ele));
    setReloadItem(!reloadItem);
  };

  const onExamChange = (ele) => {
    setSelectedExam(ele);
    setSaveButtonFlag(false);
    setConfirmClicked(true);
    setPrintFlag(true);
    setInterviewData([]);
    setReloadItem(!reloadItem);
  };


  const onSelectYear = (ele) => {
    let selectedValue = ele;
    setSelectedYear(selectedValue);
    selectedValue && dispatch(getMainsAdvertisements(selectedValue));
    if (getMainsAdvertisement) {
      getMainsAdvertisement.length = 0
    }
    if (examList) {
      examList.length = 0;
    }
    setInterviewData([])
    setSaveButtonFlag(true);

    setReloadItem(!reloadItem);
  };
  const onCancelButton = () => {
    setSelectedAdvertNo("");
    setSelectedExam("");
    setSaveButtonFlag(true);
    setConfirmClicked(false);
    setPrintFlag(true);
    setInterviewData([]);
    setReloadItem(!reloadItem);
    examList.length = 0;
    getAllotmentChartData.length = 0;
  };

  const onSubmit = () => {
    dispatch(getAllotmentChartByExamId(selectedExam));
    setReloadItem(!reloadItem);
  };

  const genPdf = () => {
    let headerDiv = '<div class="row d-flex flex-column align-items-center"><h5 class="bold-label">' + label.MPSC + '</h5><h5>' + interviewData[0].examName + '</h5><h5>' + label.AllotmentChartReport + '</h5></div>';
    const htmlContent = document.createElement('div');
    htmlContent.innerHTML = headerDiv;
    htmlContent.innerHTML += pdfRef.current.innerHTML;

    const examName = interviewData.examName;

    const options = {
      margin: [0.8, 0.2, 0.8, 0.2],
      filename: 'AllotmentChartReport.pdf',
      image: { type: 'jpeg', quality: 0.95 },
      html2canvas: { scale: 3, dpi: 300, letterRendering: true },
      jsPDF: { unit: 'in', format: 'a4', orientation: 'portrait', compressPDF: true },
    };

    html2pdf()
      .from(htmlContent)
      .set(options)
      .toPdf()
      .get('pdf')
      .then((pdf) => {
        const totalPages = pdf.internal.getNumberOfPages();

        for (let i = 1; i <= totalPages; i++) {
          pdf.setPage(i);

          const pageWidth = pdf.internal.pageSize.getWidth();
          const pageHeight = pdf.internal.pageSize.getHeight();
          const textWidth = pdf.getStringUnitWidth(`${i}`) * pdf.internal.getFontSize() / pdf.internal.scaleFactor;
          const textX = pageWidth - textWidth - 1;
          const textY = 0.8;
          const currentDate = new Date();
          const formattedDate = currentDate.toLocaleDateString('en-GB', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
          }).split('/').join('/');

          const dateWidth = pdf.getStringUnitWidth(formattedDate) * pdf.internal.getFontSize() / pdf.internal.scaleFactor;
          const dateX = pageWidth - dateWidth;
          const dateY = 0.6;
          pdf.setFontSize(8);
          pdf.text(formattedDate, dateX, dateY);
          pdf.text(`Page No. ${i}`, dateX, textY)

          const ad = interviewData[0].advertisementNo;
          const headerText = `Advertisement No. ${ad}`;
          const headerX = 0.4;
          const headerY = 0.6;

          pdf.setFontSize(8);
          pdf.text(headerText, headerX, headerY);
        }

        pdf.save(`AllotmentChartReport_${examName}.pdf`);

      });
  };

  const downloadPdf = () => {
    genPdf();
    setReloadItem(!reloadItem);
  };

  function formatDate(dateString) {
    const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };


  const groupedDataByVenue = {};

  interviewData.interviewSchedules?.forEach((item, index) => {

    const venueName = item.venueName || 'Unknown Venue';

    if (!groupedDataByVenue[venueName]) {
      groupedDataByVenue[venueName] = [];
    }

    groupedDataByVenue[venueName].push({
      interviewNumber: item.interviewNo,
      rollId: item.rollNo,
      candidateName: item.candidateName,
      interviewDate: formatDate(item.interviewDate),
      interviewTime: item.interviewTime
    });
  });


  // Group data by postCriteriaName
  const groupedData = interviewData.reduce((acc, item) => {
    const postCriteriaName = item.postCriteriaName;
    if (!acc[postCriteriaName]) {
      acc[postCriteriaName] = [];
    }
    acc[postCriteriaName].push(item);
    return acc;
  }, {});


  const combineSameCategory = (categories) => {
    return Object.values(categories.reduce((acc, category) => {
      const categoryName = category.category;
      if (!acc[categoryName]) {
        acc[categoryName] = {
          category: categoryName,
          totalNumber: 0,
          subCategories: [],
        };
      }

      acc[categoryName].totalNumber += category.totalNumber;
      acc[categoryName].subCategories.push(...(category.subCategoryDtos || []));
      return acc;
    }, {}));
  }



  return (
    <div>
      <h5 > {label.AllotmentChartReport} </h5>

      <div className="row dashboardCards">
        <div className="col-md-12">
          <form name="importForm" encType="multipart/form-data">
            <div className="form-group importFromSection">
              <div className="row">
                <div className="form-group col-md-2">
                  <label className="float-left">
                    {commonLabels.selectYear}
                    <span className="errorText">*</span>
                  </label>
                  <select
                    className="form-control"
                    name="selectedYear"
                    // ref={register({ required: true })}
                    value={selectedYear}
                    onChange={(e) => {
                      onSelectYear(e.target.value);
                    }}
                  >
                    <option key={0} value="">
                      {commonLabels.COMBO_SELECT}
                    </option>
                    {yearList &&
                      yearList.length > 0 &&
                      yearList
                        .map((element, index) => (
                          <option key={index}>{element}</option>
                          // <option key={index} value={element.id}>
                          //   {`${element.advertisementNo}/${element.year} - ${element.name}`}
                          // </option>
                        ))}
                  </select>
                  {_.get("selectedYear.type", errors) ===
                    "required" && (
                      <p className="errorText float-left">
                        {commonLabels.MANDATORY_FIELD_MESSAGE}
                      </p>
                    )}
                </div>
                <div className="form-group col-md-5">
                  <label className="float-left">
                    {commonLabels.SelectAdvertNo}
                    <span className="errorText">*</span>
                  </label>
                  <select
                    className="form-control"
                    name="selectedAdvertiseNo"
                    ref={register({ required: true })}
                    onChange={(e) => {
                      onAdvertisementChange(e.target.value);
                    }}
                  >
                    <option key={0} value="">
                      {commonLabels.COMBO_SELECT}
                    </option>
                    {getMainsAdvertisement &&
                      getMainsAdvertisement.length > 0 &&
                      getMainsAdvertisement
                        .filter(
                          (element) =>
                            element.isDeleted == false &&
                            element.isActive === true
                        )
                        .map((element, index) => (
                          <option key={index} value={element.id}>
                            {`${element.advertisementNo}/${element.year} - ${element.name}`}
                          </option>
                        ))}
                  </select>
                  {_.get("selectedAdvertiseNo.type", errors) ===
                    "required" && (
                      <p className="errorText float-left">
                        {commonLabels.MANDATORY_FIELD_MESSAGE}
                      </p>
                    )}
                </div>

                <div className="form-group col-md-4">
                  <label className="float-left">
                    {label.SelectExam}
                    <span className="errorText">*</span>
                  </label>
                  <select
                    className="form-control"
                    name="selectedExam"
                    ref={register({ required: true })}
                    onChange={(e) => {
                      onExamChange(e.target.value);
                    }}
                  >
                    <option key={0} value="">
                      {commonLabels.COMBO_SELECT}
                    </option>
                    {
                      examList &&
                      examList.length > 0 &&
                      examList
                        .filter(
                          (element) =>
                            element.isDeleted == false &&
                            element.isActive === true
                        )
                        .map((element, index) => (
                          <option key={index} value={element.id}>
                            {element.name}
                          </option>
                        ))
                    }
                  </select>
                  {_.get("selectedExam.type", errors) === "required" && (
                    <p className="errorText float-left">
                      {commonLabels.MANDATORY_FIELD_MESSAGE}
                    </p>
                  )}
                </div>

              </div>

              <div className="row">
                <div className="form-group col-md-8">
                  {(session.roleName == 'superadmin' || session.roleName == 'secretary' || session.roleName == 'desk officer') &&
                    <>    <button
                      type="reset"
                      className="btn btn-secondary mr-2"
                      onClick={() => onCancelButton()}
                    >
                      {commonLabels.BUTTON_CANCEL}
                    </button>

                      <button
                        type="submit"
                        className="btn btn-primary mr-2"
                        disabled={saveButtonFlag}
                        onClick={handleSubmit((e) => {
                          onSubmit(e);
                          setConfirmClicked(true);
                        })}
                      >
                        {commonLabels.BUTTON_VIEW}
                      </button></>}

                  {(session.roleName == 'superadmin' || session.roleName == 'secretary') && <button
                    type="button"
                    className="btn btn-primary mr-2"
                    disabled={printFlag || !confirmClicked}
                    onClick={() => {
                      downloadPdf();
                    }}
                  >
                    {commonLabels.BUTTON_PRINT}
                  </button>
                  }
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>

      {selectedExam && interviewData.length > 0 && (
        <div ref={pdfRef} className="answerKeyTable" id="interviewList">

          <>
            {/* {Object.keys(groupedData).map((postCriteriaName, index) => (
            <div key={index}>
              <h2>{postCriteriaName}</h2>
              {groupedData[postCriteriaName].map((item, itemIndex) => (
                <div key={itemIndex}>
                  <h3>{item.postCriteriaName}</h3>
                  {item.categoryDtos.map((category, catIndex) => (
                    <div key={catIndex}>
                      <h4>{category.name}</h4>
                      {category.subCategoryDtos.map((subCategory, subCatIndex) => (
                        <div key={subCatIndex}>
                          <h5>{subCategory.name}</h5>
                          <table>
                            <thead>
                              <tr>
                                <th>Serial Number</th>
                                <th>Token Number</th>
                              </tr>
                            </thead>
                            <tbody>
                              {subCategory.tokenNumberList && subCategory.tokenNumberList.map((token, tokenIndex) => (
                                <tr key={tokenIndex}>
                                  <td>{token.serialNo}</td>
                                  <td>{token.tokenNo}</td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      ))}
                    </div>
                  ))}
                </div>
              ))}
            </div>
          ))} */}
            {Object.keys(groupedData).map((postCriteriaName, index) => (
              <div key={index}>
                {groupedData[postCriteriaName].map((item, itemIndex) => (
                  <div key={itemIndex}>
                    <h5 className="text-center">
                      <span style={{ display: 'inline-block', width: '300px', backgroundColor: 'grey' }}>{item.postCriteriaName} - {item.totalCount}</span>
                    </h5>
                    {Object.values(combineSameCategory(item.categoryDtos)).map((mergedCategory, mergedCatIndex) => (
                      <div key={mergedCatIndex}>
                        <div className="d-flex align-items-center mt-3">
                          <h4 className="border border-dark w-25 d-flex justify-content-between">
                            <span className="ml-3">{mergedCategory.category}</span>
                            <span className="ml-auto mr-3">{mergedCategory.totalNumber}</span>
                          </h4>
                        </div>
                        {mergedCategory.subCategories.map((subCategory, subCatIndex) => (
                          <div key={subCatIndex}>
                            <h5 className="mt-3">{subCategory.name}</h5>
                            <table>
                              <tbody>
                                {subCategory.tokenNumberList && subCategory.tokenNumberList.map((token, tokenIndex) => (
                                  <>
                                    {tokenIndex % 8 === 0 && <tr className="token-row"></tr>}
                                    <td className="text-center custom-td">{token.serialNo}</td>
                                    <td className="text-center custom-td">{token.tokenNo}</td>
                                    <td></td>
                                  </>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        ))}
                      </div>
                    ))}
                  </div>
                ))}
              </div>
            ))}
          </>

        </div>
      )}
    </div>
  );
};

export default AllotmentChartReport;
